import React, { useState, useEffect } from 'react';
import DataTable from '../../common/Table';
import { db } from '../../../firebase';
import { get, onValue, orderByChild, query, ref, remove } from 'firebase/database';
import { errorToast, successToast } from '../../common/toast';
import { useNavigate } from 'react-router-dom';

const QCReports = () => {
  const [qcReports, setQCReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const columns = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Mobile",
      accessor: "number",
    },
    {
      Header: "Start Date",
      accessor: "startDate",
    },
    {
      Header: "End Date",
      accessor: "endDate",
    },
    {
      Header: "Caller Name",
      accessor: "callerName",
      Cell: ({ value }) => value?.label
    },
    {
      Header: "User Address",
      accessor: "userAddress",
    },
    {
      Header: "Total Forms",
      accessor: "totalForms",
      filter: false,
    },
    {
      Header: "Submitted Forms",
      accessor: "submittedForms",
      filter: false,
    },
    {
      Header: "Wrong Forms",
      accessor: "wrongForms",
      filter: false,
    },
    {
      Header: "Right Forms",
      accessor: "rightForms",
      filter: false,
    },
  ];

  const handleDelete = async (user) => {
    if (window.confirm(`Are you sure you want to delete ${user.email}?`)) {
      try {
        const userRef = ref(db, `qcReports/${user.id}`);
        await remove(userRef);
        successToast(`${user.email} has been deleted!`);
        fetchQCReports();
      } catch (error) {
        errorToast("Error deleting user: " + error.message);
      }
    }
  };

  const handleEdit = async (user) => {
    return navigate(`/admin/qc-reports-view/${user?.userId}`, { state: user });
  };

  const actionButtons = [
    {
      icon: 'bi bi-eye',
      onClick: handleEdit,
    },
    {
      icon: 'bi bi-trash',
      color: 'danger',
      onClick: handleDelete,
    },
  ];

  const fetchQCReports = () => {
    setIsLoading(true);

    const qcReportsRef = query(ref(db, "qcReports"), orderByChild("registrationDate"));
    const usersRef = ref(db, "users");

    let qcReportsData = [];
    let usersDataMap = {};

    get(usersRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          usersDataMap = snapshot.val();
        }

        onValue(qcReportsRef, (snapshot) => {
          if (snapshot.exists()) {
            const qcReports = snapshot.val();

            qcReportsData = Object.keys(qcReports).map((id) => {
              const reportData = qcReports[id];
              const userId = reportData.userId;

              return {
                id,
                ...reportData,
                name: usersDataMap[userId]?.name || "N/A",
                number: usersDataMap[userId]?.number || "N/A",
                email: usersDataMap[userId]?.email || "N/A",
                startDate: usersDataMap[userId]?.startDate || "N/A",
                endDate: usersDataMap[userId]?.endDate || "N/A",
                callerName: usersDataMap[userId]?.caller || "N/A",
                userAddress: usersDataMap[userId]?.address || "N/A",
              };
            });
            qcReportsData.reverse();
          }

          setQCReports(qcReportsData);
          setIsLoading(false);
        });
      })
      .catch((error) => {
        errorToast("Error while fetching QC reports data: " + error.message);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchQCReports();
  }, []);

  return (
    <>
      <DataTable
        title={"QCReports"}
        isLoading={isLoading}
        tableData={qcReports}
        columns={columns}
        actionButtons={actionButtons}
      />
    </>
  );
};

export default QCReports;
